import Heading from "components/Heading";
import type { ReactStoryblokComponent } from "types/storyblok";
import { useBreakpointValue } from "@chakra-ui/react";
import type { HeadingAdapterProps } from "./Heading.d";
import headingVarinats from "./Heading.config";

const HeadingAdapter = ({
  blok: { text, type: variant, color, mbDesktop, mbMobile },
  sbEditable,
}: ReactStoryblokComponent<HeadingAdapterProps>) => {
  const marginBottom = useBreakpointValue({ base: mbMobile, lg: mbDesktop });

  return (
    <Heading
      as={`h${variant}`}
      text={text}
      marginBottom={marginBottom}
      variant={headingVarinats[variant]}
      color={color}
      sbEditable={sbEditable}
    />
  );
};

export default HeadingAdapter;
